/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-underscore-dangle */
import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Stat } from 'src/models/stat';

import { Account } from '../../models/account';
import { AppInsightsService } from '../app-insights.service';
import { LocalStorageService } from '../local-storage';

@Injectable({
    providedIn: 'root'
})
export class UserManager {
    selectedStat: Stat;
    private _account: BehaviorSubject<Account> = new BehaviorSubject(new Account());
    public readonly account: Observable<Account> = this._account.asObservable();

    public getCurrentAccount(): Account {
        return this._account.getValue();
    }

    constructor(
        private storage: LocalStorageService,
        private insights: AppInsightsService) {
        this.init().then(() => { });
    }

    async init() {
        const data = await this.storage.getEntity<Account>('account');
        await this.receiveAccount(data);
    }

    async receiveAccount(account: Account) {
        if (account) {
            this._account.next(Account.create(account));

            if (account.id) {
                await this.storage.updateEntity('account', account);
                this.insights.setUserId(account.id.toString());
            }
        }
    }

    async clearUser() {
        this._account.next(null);
        this.insights.clearUserId();
    }
}
